import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sc-banner" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col sc-banner-item text-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { id: "nav" }
const _hoisted_7 = { class: "navbar sticky-top navbar-expand py-0" }
const _hoisted_8 = { class: "container navbar-light bg-light" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler px-0 py-0",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "true",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_10 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_11 = { class: "navbar-nav me-auto mb-lg-0" }
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("发起求助")
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("求助信息")
const _hoisted_16 = { class: "nav-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi-info-circle text-secondary" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: _ctx.BannerForeground,
              alt: "banner image"
            }, null, 8, _hoisted_5)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("nav", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: { name: "get-help" }
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: { name: "dashboard" }
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_router_link, {
                  class: "nav-link",
                  to: { name: "auth" }
                }, {
                  default: _withCtx(() => [
                    _hoisted_17
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}